import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-surface border-t border-border print:hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        {/* Main grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-10">

          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-3 group mb-5">
              <img
                src="/images/logo-corpcore.png"
                alt="Corpcore"
                width="40"
                height="40"
                loading="lazy"
                className="h-10 w-10 brightness-0 invert group-hover:brightness-100 group-hover:invert-0 transition-all duration-300"
              />
              <span className="font-bold text-xl text-white group-hover:text-brand-sky transition-colors">
                Corpcore
              </span>
            </Link>
            <p className="text-sm text-text-secondary leading-relaxed mb-5 max-w-xs">
              Agents IA pour automatiser vos tâches répétitives — community management, relances clients, extraction comptable. Hébergés en Suisse.
            </p>
            <div className="flex gap-2">
              <a
                href="https://www.linkedin.com/company/corpcorebusiness"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-xl border border-border flex items-center justify-center text-text-secondary hover:text-white hover:border-brand-sky hover:bg-brand-sky/10 transition-all"
                aria-label="LinkedIn Corpcore"
              >
                <Linkedin size={16} />
              </a>
              <a
                href="https://www.instagram.com/corpcore_business/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-xl border border-border flex items-center justify-center text-text-secondary hover:text-white hover:border-brand-sky hover:bg-brand-sky/10 transition-all"
                aria-label="Instagram Corpcore"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-text-secondary mb-4">Navigation</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Accueil', to: '/' },
                { label: 'Nos Agents', to: '/services' },
                { label: 'Partenaires', to: '/partners' },
                { label: 'À propos', to: '/about' },
                { label: 'Contact', to: '/contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-text-secondary hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Ressources */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-text-secondary mb-4">Ressources</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Articles & Guides', to: '/articles' },
                { label: 'Études de cas', to: '/etudes-de-cas' },
                { label: 'Outils gratuits', to: '/ressources' },
                { label: 'Calculateur ROI', to: '/ressources#calculateur' },
                { label: 'Checklist audit', to: '/checklist-audit-processus' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-text-secondary hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-text-secondary mb-4">Contact</h3>
            <div className="space-y-3">
              <a
                href="mailto:info@corpcore.ch"
                className="flex items-center gap-2.5 text-sm text-text-secondary hover:text-white transition-colors group"
              >
                <Mail size={14} className="text-brand-sky flex-shrink-0" />
                info@corpcore.ch
              </a>
              <a
                href="https://maps.app.goo.gl/Ym9KsVpCNuAdBBUm7"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2.5 text-sm text-text-secondary hover:text-white transition-colors"
              >
                <MapPin size={14} className="text-brand-sky flex-shrink-0 mt-0.5" />
                <span>Rue du Château 11<br />1030 Bussigny, Suisse</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-text-secondary">
            © {currentYear} Corpcore — Agents IA & Automatisation pour PME suisses
          </p>
          <div className="flex gap-5">
            <Link to="/confidentialite" className="text-xs text-text-secondary hover:text-white transition-colors">
              Confidentialité
            </Link>
            <Link to="/mentions-legales" className="text-xs text-text-secondary hover:text-white transition-colors">
              Mentions légales
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
